// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__j6gbF","head":"Table_head__J8beU","col":"Table_col__3M-n-"};